/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Guide_Stat_3Inputs */

const en_landing_guide_stat_3 = /** @type {(inputs: Landing_Guide_Stat_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`94-99%`)
};

const zh_landing_guide_stat_3 = /** @type {(inputs: Landing_Guide_Stat_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`94%-99%`)
};

/**
* | output |
* | --- |
* | "94-99%" |
*
* @param {Landing_Guide_Stat_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_guide_stat_3 = /** @type {((inputs?: Landing_Guide_Stat_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Guide_Stat_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_guide_stat_3(inputs)
	return zh_landing_guide_stat_3(inputs)
});
export { landing_guide_stat_3 as "landing.guide.stat_3" }